export const noPaddingStyle = {
  paddingLeft: '0px',
  paddingRight: '0px',
  paddingTop: '0px',
  paddingBottom: '0px',
  height: '100%',
  width: '100%',
};

export const noPaddingStyle85 = {
  ...noPaddingStyle,
  height: '85%',
};
